import React, { useEffect, useRef, useState } from 'react';
import { Loader, Dimmer, TableBody, TableCell, TableRow } from 'semantic-ui-react';
import Modal from 'react-bootstrap/Modal';
import axios from 'axios';
import { Mensaje, MensajeSiNo } from '../mensajes';
import moment from 'moment';
import CatalogoProductosExistencias from '../../catalogos/catalogoProductosExistencias';
import CatalogoAlmacen from '../../catalogos/catalogoAlmacen';

export const ModalClientes = (props) => {

  var op = require('../../../public/modulos/datos');
  let token = sessionStorage.getItem('jwtToken');
  const fechasistema = JSON.parse(sessionStorage.getItem('fechasistema'));
  const afiliado = JSON.parse(sessionStorage.getItem("riforganizacion"));

  const btnCancela = useRef();
  const btnAcepta = useRef();
  const btnSalir = useRef();
  const txtEstado = useRef();
  const txtMunicipio = useRef();
  const txtCiudad = useRef();
  const txtTodosEstados = useRef();
  const txtPorEstados = useRef();
  const txtTodosDispo = useRef();
  const txtActivos = useRef();
  const txtInactivos = useRef();

  const [disponiblec, setDisponiblec] = useState('');
  const [activate, setActivate] = useState(false);
  const [valida, setValida] = useState(0);
  const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
  const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
  const [estado, setEstado] = useState([]);
  const [municipio, setMunicipio] = useState([]);
  const [ciudad, setCiudad] = useState([]);
  const [paracliente, setParacliente] = useState('');
  const [idsc, setIdsc] = useState([]);
  const [valestado, setValestado] = useState(0);

  const blanquear = () => {
    setValestado(0);
    setActivate(false);
    setDisponiblec('');
  }

  const cancelar = () => {
    blanquear();
    props.onHideCancelar();
  };

  const onChangeValidar = (e) => {
    e.preventDefault();
    let sigue = true;
    if (valestado !== 0 && txtMunicipio.current.value === '') {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Seleccione un municipio para generar el reporte.",
        icono: "informacion",
      });
      sigue = false;
      txtMunicipio.current.focus();
    } else if (valestado !== 0 && txtCiudad.current.value === '') {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Seleccione una ciudad para generar el reporte.",
        icono: "informacion",
      });
      sigue = false;
      txtCiudad.current.focus();
    }

    if (sigue) {
      let val1 = '';
      let condi = 'cliente = true' + paracliente + disponiblec;

      window.open(
        `${op.reportes}/clientes?afiliado=${afiliado}&reporte=ListaCliente&condicion=${condi}`,
        "Planilla",
        "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
      )
    }
  }

  const cerrarModal = () => {
    blanquear();
    setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
    props.onHideCancelar();
    props.onCerrar();
  }

  const onChange = (e) => {
    if (e.target.name === 'estado') {
      if (txtTodosEstados.current.checked === true) {
        if (txtMunicipio.current) txtMunicipio.current.value = '';
        if (txtCiudad.current) txtCiudad.current.value = '';
        setParacliente('');
        setValestado(0);
      } else {
        setParacliente('');
        setValestado(1);
        seleccionarClient();
      }
    } else if (e.target.name === 'tipodisponible') {
      if (txtTodosDispo.current.checked === true) {
        setParacliente('');
        setDisponiblec('');
      } else if (txtActivos.current.checked === true) {
        setParacliente('');
        setDisponiblec(' and statuscliente = 51 ');
      } else if (txtInactivos.current.checked === true) {
        setParacliente('');
        setDisponiblec(' and statuscliente != 51 ');
      }
    }
  }

  const handleInputNumeroChange = (event) => {
    event.preventDefault();
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        if (event.target.name === "numnota") {
          btnAcepta.current.focus();
        }
      }
    }
  };

  const seleccionarRegistro = () => {
    const campos = "estado,municipio,ciudad";
    const nomtab = "organizacion";
    const endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&nomtab=${nomtab}&nomid=rif&id=${afiliado}`;

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data !== "") {
            const data = response.data;
            selectEstado(data.estado);
            selectMunicipios(data.estado, () => {
              if (txtMunicipio.current) {
                txtMunicipio.current.value = data.municipio;
                selectCiudad(data.municipio, () => {
                  if (txtCiudad.current) {
                    txtCiudad.current.value = data.ciudad;
                    if (valestado === 1) {
                      seleccionarClient();
                    }
                  }
                });
              }
            });
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const selectEstado = (id) => {
    let campos = "*";
    let nomtab = "estado";
    let nomid = "idestado";
    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setEstado([response.data]);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const selectMunicipios = (id, callback) => {
    let campos = "*";
    let nomtab = "municipio";
    let nomid = "idestado";
    let endpoint = `${op.conexion}/api/consulta/modelirows?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setMunicipio(response.data);
          if (callback) callback();
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const selectCiudad = (id, callback) => {
    let campos = "*";
    let nomtab = "ciudad";
    let nomid = "idmunicipio";
    let endpoint = `${op.conexion}/api/consulta/modelirows?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setCiudad(response.data);
          if (callback) callback();
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const handleMunicipioChange = () => {
    if (txtMunicipio.current && txtMunicipio.current.value && valestado === 1) {
      const idMunicipio = txtMunicipio.current.value;
      selectCiudad(idMunicipio, () => {
        if (txtCiudad.current) {
          txtCiudad.current.value = '';
        }
        setParacliente('');
      });
    }
  };

  const handleCiudadChange = () => {
    if (txtCiudad.current && txtCiudad.current.value && valestado === 1 && txtMunicipio.current && txtMunicipio.current.value) {
      setParacliente('');
      seleccionarClient();
    }
  };

  useEffect(() => {
    if (txtMunicipio.current) {
      const handleChange = () => {
        if (valestado === 1) {
          const idMunicipio = txtMunicipio.current.value;
          if (idMunicipio) {
            selectCiudad(idMunicipio, () => {
              if (txtCiudad.current) {
                txtCiudad.current.value = '';
              }
              setParacliente('');
            });
          }
        }
      };
      txtMunicipio.current.addEventListener('change', handleChange);
      return () => {
        if (txtMunicipio.current) {
          txtMunicipio.current.removeEventListener('change', handleChange);
        }
      };
    }
  }, [valestado, municipio]);

  useEffect(() => {
    if (txtCiudad.current) {
      const handleChange = () => {
        if (valestado === 1 && txtCiudad.current.value && txtMunicipio.current && txtMunicipio.current.value) {
          setParacliente('');
          seleccionarClient();
        }
      };

      txtCiudad.current.addEventListener('change', handleChange);
      return () => {
        if (txtCiudad.current) {
          txtCiudad.current.removeEventListener('change', handleChange);
        }
      };
    }
  }, [valestado, ciudad]);

  const seleccionarClient = () => {

    let campos = 'idagente';
    let nomtab = 'agente';
    let condi = "cliente = true and municipio = '" + txtMunicipio.current.value + "'" + " and ciudad = '" + txtCiudad.current.value + "'";
    let orden = 'idagente';

    let endpoint = `${op.conexion}/api/consulta/selecionarregistrocondi?&campos=${campos}&nomtab=${nomtab}&condi=${condi}&orden=${orden}`;

    setActivate(true);

    axios.get(endpoint, {
      headers: {
        'x-access-token': `${token}`
      }
    }).then(function (response) {
      if (response.status === 200) {
        if (response.data.length > 0) {
          let ids = [];
          for (let i = 0; i < response.data.length; i++) {
            ids.push(parseInt(response.data[i].idagente));
          }
          setParacliente(' and idagente in(' + ids + ')');
          setIdsc(ids)
        }
      } else {
      }
    }).catch(function (error) {
      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
      setActivate(false);
    }).finally(() => {
      setActivate(false);
    })
  }

  return (
    <Modal
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {

        seleccionarRegistro(afiliado);
        setValestado(0);
        txtTodosEstados.current.checked = true;
        txtPorEstados.current.checked = false;
        txtTodosDispo.current.checked = true;
        txtActivos.current.checked = false;
        txtInactivos.current.checked = false;
        setDisponiblec('');

      }}
    >
      <Modal.Header className='azulGradiant2 header-modal'>
        <div className='fw-bold' style={{ color: "#fff" }}><h3>IMPRIMIR LISTA DE CLIENTES</h3></div>

        <a href='#' ref={btnSalir} onClick={cancelar} className='text-light' ><i className="fas fa-times fa-1x shadow" > {/* Salir */}</i></a>

      </Modal.Header>
      <Modal.Body style={{ backgroundColor: "#FFF" }}>
        <Mensaje mensaje={mensaje}
          onHide={() => {
            mensaje.titulo === 'Exito.' ?
              cerrarModal() :
              setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })
          }
          } />
        <Dimmer active={activate} inverted>
          <Loader inverted>cargando...</Loader>
        </Dimmer>
        <div className='col-md-12 row mx-auto px-0 m-0'>

          <div className='col-12 row m-0 px-0 py-2'>

            <fieldset className='row col-sm-12 d-flex justify-content-center border-azul rounded mb-1 mx-auto'>
              <legend className="float-none m-0 w-auto fs-4 fw-bold">Estatus del Cliente:</legend>

              <div className='col-3'>
                <div className="form-check">
                  <input className="form-check-input" name="tipodisponible" value="1" ref={txtTodosDispo} onChange={onChange} id="tipodisponible" type="radio" />
                  <label className="form-check-label" for="exampleRai1">
                    Todos
                  </label>
                </div>
              </div>

              <div className='col-3'>
                <div className="form-check">
                  <input className="form-check-input" name="tipodisponible" value="2" ref={txtActivos} onChange={onChange} id="tipodisponible" type="radio" />
                  <label className="form-check-label" for="exampleRai2">
                    Activos
                  </label>
                </div>
              </div>

              <div className='col-3'>
                <div className="form-check">
                  <input className="form-check-input" name="tipodisponible" value="3" ref={txtInactivos} onChange={onChange} id="tipodisponible" type="radio" />
                  <label className="form-check-label" for="exampleRai3">
                    Inactivos
                  </label>
                </div>
              </div>

            </fieldset>

            <fieldset className='row col-sm-12 mx-auto border-azul rounded mb-1'>
              <legend className="float-none m-0 w-auto fs-4 fw-bold">Estado:</legend>

              <div className='col-3 mx-auto'>
                <div className="form-check">
                  <input className="form-check-input" name="estado" value="1" ref={txtTodosEstados} onChange={onChange} id="estado" type="radio" />
                  <label className="form-check-label" for="exampleRa1">
                    Todos
                  </label>
                </div>
              </div>

              <div className='col-3 mx-auto'>
                <div className="form-check">
                  <input className="form-check-input" name="estado" value="2" ref={txtPorEstados} onChange={onChange} id="estado" type="radio" />
                  <label className="form-check-label" for="exampleRa2">
                    Por Estado
                  </label>
                </div>
              </div>

              <div className='col-12 row m-0 py-2'>
                <div className='col-12 mr-auto px-1'>
                  <div class="input-group input-group-sm mb-1">
                    <label className="input-group-text" for="inputGroupSelect01">ESTADO</label>
                    <select className="form-select" id="inputGroupSelect01" ref={txtEstado} disabled={valestado === 1 ? false : true}>
                      {estado.map((item2, x) => (
                        <option key={x} value={item2.idestado}>
                          {" "}
                          {item2.nombre}{" "}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className='col-12 mr-auto px-1'>
                  <div class="input-group input-group-sm mb-1">
                    <label className="input-group-text" for="inputGroupSelect02">MUNICIPIO</label>
                    <select
                      className="form-select"
                      id="inputGroupSelect02"
                      ref={txtMunicipio}
                      onChange={handleMunicipioChange}
                      disabled={valestado === 1 ? false : true}
                    >
                      <option value="">Seleccione un municipio</option>
                      {municipio.map((item2, x) => (
                        <option key={x} value={item2.idmunicipio}>
                          {" "}
                          {item2.nombre}{" "}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className='col-12 mr-auto px-1'>
                  <div class="input-group input-group-sm mb-1">
                    <label className="input-group-text" for="inputGroupSelect03">CIUDAD</label>
                    <select
                      className="form-select"
                      id="inputGroupSelect03"
                      ref={txtCiudad}
                      onChange={handleCiudadChange}
                      disabled={valestado === 1 ? false : true}
                    >
                      <option value="">Seleccione una ciudad</option>
                      {ciudad.map((item2, x) => (
                        <option key={x} value={item2.idciudad}>
                          {" "}
                          {item2.nombre}{" "}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>

            </fieldset>

          </div>

        </div>


      </Modal.Body >
      <Modal.Footer>
        <div className="row m-0 col-md-12 mx-auto">
          <div className='col-md-11 ml-auto px-0 m-0 d-flex justify-content-end'>
            <button ref={btnAcepta} onClick={onChangeValidar} className="btn btn-sm rounded-pill btn-success mx-1"><i className="fas fa-check-circle">  Aceptar</i></button>
            <button ref={btnCancela} onClick={cancelar} className="btn btn-danger btn-sm rounded-pill mx-1"><i className="fas fa-window-close"> Cancelar</i></button>
          </div>
        </div>

      </Modal.Footer>
      {/* <CatalogoAlmacen
        show={mostrar2}
        onHideCancelar={() => setMostrar2(false)}
        onHideAceptaCatalogo={handleAceptaAlmacen}
      /> */}
    </Modal >
  );
}




// WEBPACK FOOTER //
// ./src/components/ventas/modalClientes.js